(function ()
{
	function Keyboard()
	{
		throw "Keyboard cannot be instantiated.";
	}

	Keyboard.isUsingKeyboard = false;
	Keyboard.bindings = {};
	Keyboard.actions = {};
	Keyboard.presses = {};
	Keyboard.locks = {};
	Keyboard.delayedKeyup = {};
	Keyboard.KEYS = {
		'BACKSPACE': 8,
		'TAB': 9,
		'ENTER': 13,
		'PAUSE': 19,
		'CAPS': 20,
		'ESC': 27,
		'SPACE': 32,
		'PAGE_UP': 33,
		'PAGE_DOWN': 34,
		'END': 35,
		'HOME': 36,
		'LEFT_ARROW': 37,
		'UP_ARROW': 38,
		'RIGHT_ARROW': 39,
		'DOWN_ARROW': 40,
		'INSERT': 45,
		'DELETE': 46,
		'_0': 48,
		'_1': 49,
		'_2': 50,
		'_3': 51,
		'_4': 52,
		'_5': 53,
		'_6': 54,
		'_7': 55,
		'_8': 56,
		'_9': 57,
		'A': 65,
		'B': 66,
		'C': 67,
		'D': 68,
		'E': 69,
		'F': 70,
		'G': 71,
		'H': 72,
		'I': 73,
		'J': 74,
		'K': 75,
		'L': 76,
		'M': 77,
		'N': 78,
		'O': 79,
		'P': 80,
		'Q': 81,
		'R': 82,
		'S': 83,
		'T': 84,
		'U': 85,
		'V': 86,
		'W': 87,
		'X': 88,
		'Y': 89,
		'Z': 90,
		'NUMPAD_0': 96,
		'NUMPAD_1': 97,
		'NUMPAD_2': 98,
		'NUMPAD_3': 99,
		'NUMPAD_4': 100,
		'NUMPAD_5': 101,
		'NUMPAD_6': 102,
		'NUMPAD_7': 103,
		'NUMPAD_8': 104,
		'NUMPAD_9': 105,
		'MULTIPLY': 106,
		'ADD': 107,
		'SUBSTRACT': 109,
		'DECIMAL': 110,
		'DIVIDE': 111,
		'F1': 112,
		'F2': 113,
		'F3': 114,
		'F4': 115,
		'F5': 116,
		'F6': 117,
		'F7': 118,
		'F8': 119,
		'F9': 120,
		'F10': 121,
		'F11': 122,
		'F12': 123,
		'SHIFT': 16,
		'CTRL': 17,
		'ALT': 18,
		'PLUS': 187,
		'COMMA': 188,
		'MINUS': 189,
		'PERIOD': 190
	};

	Keyboard.start = function()
	{
		if( Keyboard.isUsingKeyboard ) { return; }
		Keyboard.isUsingKeyboard = true;
		window.addEventListener('keydown', Keyboard.keydown.bind(Keyboard), false );
		window.addEventListener('keyup', Keyboard.keyup.bind(Keyboard), false );
	};

	Keyboard.keydown = function( event )
	{
		var nativeEvent = event.nativeEvent || event;
		var tag = nativeEvent.target.tagName;
		if( tag === 'INPUT' || tag === 'TEXTAREA' ) { return; }

		var code = nativeEvent.keyCode;

		var action = Keyboard.bindings[code];
		if( action ) {
			Keyboard.actions[action] = true;
			if( !Keyboard.locks[action] ) {
				Keyboard.presses[action] = true;
				Keyboard.locks[action] = true;
			}

			event.stopPropagation();
			event.preventDefault();
		}
	};

	Keyboard.keyup = function( event )
	{
		var nativeEvent = event.nativeEvent || event;
		var tag = nativeEvent.target.tagName;
		if( tag === 'INPUT' || tag === 'TEXTAREA' ) { return; }

		var code = nativeEvent.keyCode;

		var action = Keyboard.bindings[code];
		if( action ) {
			Keyboard.delayedKeyup[action] = true;
			event.stopPropagation();
			event.preventDefault();
		}
	};

	Keyboard.bind = function( key, action )
	{
		Keyboard.start();
		Keyboard.bindings[key] = action;
	};

	Keyboard.unbind = function( key )
	{
		var action = Keyboard.bindings[key];
		Keyboard.delayedKeyup[action] = true;

		Keyboard.bindings[key] = null;
	};

	Keyboard.unbindAll = function()
	{
		Keyboard.bindings = {};
		Keyboard.actions = {};
		Keyboard.presses = {};
		Keyboard.locks = {};
		Keyboard.delayedKeyup = {};
	};

	Keyboard.state = function( action )
	{
		return Keyboard.actions[action];
	};

	Keyboard.pressed = function( action )
	{
		return Keyboard.presses[action];
	};

	Keyboard.released = function( action )
	{
		return !!Keyboard.delayedKeyup[action];
	};

	Keyboard.clearPressed = function()
	{
		for( var action in Keyboard.delayedKeyup ) {
			Keyboard.actions[action] = false;
			Keyboard.locks[action] = false;
		}
		Keyboard.delayedKeyup = {};
		Keyboard.presses = {};
	};

	cm.Keyboard = Keyboard;
})();